export const DB_CONFIG = {
  apiKey: "AIzaSyDvX0rqrRLHKLHfvXMuTYEGwBFH6deGxbk",
  authDomain: "taskadministrator.firebaseapp.com",
  databaseURL: "https://taskadministrator.firebaseio.com",
  projectId: "taskadministrator",
  storageBucket: "taskadministrator.appspot.com",
  messagingSenderId: "695555198338"
};
